class Authenticate
{
    constructor(container){
        this.container = $(container);

        this.container.find('#js-register-form').on(
            'submit',
            this.registerHandler.bind(this)
        );

        this.container.find('#js-login-form').on(
            'submit',
            this.loginHandler.bind(this)
        );
    }

    loginHandler(e){
        e.preventDefault();

        $("#js-login-form button").hide();
        $("#js-login-form .deal-request-preloader").css('display', 'block');

        let thisForm = $(e.currentTarget);

        this.sendAjax(thisForm, 'login');
    }

    registerHandler(e){
        e.preventDefault();

        if($("#js-register-form .register-privacy input").is(":checked"))
        {
            $("#js-register-form button").hide();
            $("#js-register-form .deal-request-preloader").css('display', 'block');

            let thisForm = $(e.currentTarget);

            this.sendAjax(thisForm, 'register');
        }
        else{
            errorNoty(__('You forgot to check the box agreeing to the privacy policy.'));
        }
    }

    // регистрация прошла успешна
    done(data){
        if(data.reload){
            location.reload();
        }
        else if(data.two_factor)
        {
            $("#js-login-form .deal-request-preloader").hide();
            $("#js-login-form button").css('display', 'block');
            $("#js-login-form input[name='two_factor']").css('display', 'block');
            siteCaptcha.reset(loginCaptcha);

            successNoty(__('We have sent a confirmation code to your email, enter it in the field that appeared.'));
        }
        else if(data.reg_confirmation)
        {
            $("#js-register-form .deal-request-preloader").hide();
            $("#js-register-form button").css('display', 'block');
            $("#js-register-form button").css('display', 'block');
            $("#email-confirmation-modal .confirm-submit__submit").attr('data-id', data.user_id);
            $("#email-confirmation-modal").modal('show');
        }
    }

    sendAjax(thisForm, type){
        $.post(thisForm.attr('action'), thisForm.serialize())
            .done(this.done)
            .fail(function(){
                if(type == 'register'){
                    $("#js-register-form .deal-request-preloader").hide();
                    $("#js-register-form button").css('display', 'block');
                }else if(type == 'login'){
                    $("#js-login-form .deal-request-preloader").hide();
                    $("#js-login-form button").css('display', 'block');
                }
                siteCaptcha.reset(registerCaptcha);
                siteCaptcha.reset(loginCaptcha);
            })
        ;
    }
}

window.Authenticate = Authenticate;